import { render } from "./U1075u1083u1072u1074u1085u1072u1103.vue?vue&type=template&id=48951a78&scoped=true"
import script from "./U1075u1083u1072u1074u1085u1072u1103.vue?vue&type=script&lang=js"
export * from "./U1075u1083u1072u1074u1085u1072u1103.vue?vue&type=script&lang=js"

import "./U1075u1083u1072u1074u1085u1072u1103.vue?vue&type=style&index=0&id=48951a78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48951a78"]])

export default __exports__